import React from "react";
import PropTypes from 'prop-types';
import { getMenuItemsByPermisos } from "../router/menuItems";
import { useAuth } from "../context/AuthContext";
import { NavLink, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { useEmpresaLogos } from "../hooks/useEmpresaLogos";

const Sidebar = ({
  user,
  customMenuItems,
  token,
  isOpen,
}) => {
  const { usuario } = useAuth();
  const menuItems = getMenuItemsByPermisos(usuario?.permisos);
  const { logos } = useEmpresaLogos();

  const location = useLocation();

  const getActiveTabId = () => {
    const pathname = location.pathname;

    const matchedItem = menuItems
      .filter(
        (item) => pathname === item.path || pathname.startsWith(item.path + "/")
      )
      .sort((a, b) => b.path.length - a.path.length)[0]; 

    return matchedItem?.id;
  };

  const activeTabId = getActiveTabId();

  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      <div className="sidebar2">
        <div className="sidebar-header">
          <div className="logo-container">
            <img src={logos.logo_dashboard} alt="Logo" className="sidebar-logo" />
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">
            {menuItems.map((item) => {
              const isActive = activeTabId === item.id;
              return (
                <div
                  key={item.id}
                  className={`nav-background ${isActive ? "activebac" : ""}`}
                >
                  <NavLink
                    to={item.path}
                    end={item.path === "/admin"}
                    className={`nav-item `}
                  >
                    <div className="nav-content">
                      {item.icon && (
                        <span className="nav-icon">{item.icon}</span>
                      )}
                      <span className="nav-label">{item.label}</span>
                    </div>
                  </NavLink>
                </div>
              );
            })}
          </div>
        </nav>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  user: PropTypes.shape({
    nombre: PropTypes.string,
    apellidoPaterno: PropTypes.string,
    rol: PropTypes.string,
    permisos: PropTypes.array, 
  }),
  customMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, 
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.node 
    })
  ),
  token: PropTypes.string,
  isOpen: PropTypes.bool.isRequired
};

export default Sidebar;
